/* unplugin-vue-components disabled */import script from "./OpeningAnalysisView.vue?vue&type=script&setup=true&lang=js"
export * from "./OpeningAnalysisView.vue?vue&type=script&setup=true&lang=js"

import "./OpeningAnalysisView.vue?vue&type=style&index=0&id=6cb40e97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cb40e97"]])

export default __exports__